module.exports = __webpack_public_path__ + "img/about_2_3.cce1c3e0.jpg";